/** 일정시간 대기 */
export const delayTimeout = (timeout: number) =>
    new Promise((resolve) => {
        setTimeout(() => {
            resolve(null)
        }, timeout)
    })

export const nextTick = (cb: () => void) => {
    setTimeout(() => {
        cb()
    }, 0)
}
